export enum ShowCardType {
  Past = "Past",
  Scheduled = "Scheduled",
  Live = "Live",
}

export type BaseShowCardProps = {
  /**
   * The type of show card.
   */
  type: ShowCardType

  /**
   * The title of the show.
   */
  title: string | null

  /**
   * The URL of the thumbnail image for the show.
   */
  thumbnailUrl: string

  /**
   * The URL of the channel avatar image.
   */
  channelAvatarUrl?: string | null

  /**
   * The name of the channel.
   */
  channelName?: string | null

  /**
   * If true, the show card will stretch to the full width of its container.
   * @default false
   */
  fullWidth?: boolean
} & Pick<React.HTMLAttributes<HTMLButtonElement>, "onClick">

export type PastShowCardProps = BaseShowCardProps & {
  type: ShowCardType.Past

  /**
   * The duration of the show in seconds.
   */
  duration: number

  /**
   * The start time of the show.
   */
  startTime: Date

  /**
   * The end time of the show.
   */
  endTime?: Date
}

export type ScheduledShowCardProps = BaseShowCardProps & {
  type: ShowCardType.Scheduled

  /**
   * The scheduled start date of the show.
   */
  scheduledStartDate: Date
}

export type LiveShowCardProps = BaseShowCardProps & {
  type: ShowCardType.Live

  /**
   * The start time of the show.
   */
  startedAt?: Date
}
